export enum CreditDebit {
  CREDIT = "credit",
  DEBIT = "debit",
  BOTH = "both",
}

export enum CalculationBasis {
  PER_DOCUMENT = "per_document",
  BUSINESS_BALANCE = "business_balance",
}

export const CalculationBasisDisplayNameMap: Record<CalculationBasis, string> =
  {
    [CalculationBasis.PER_DOCUMENT]: "Per Document",
    [CalculationBasis.BUSINESS_BALANCE]: "Business Balance",
  };
